import { AppTextInput } from "../../ui/input";
import { AuthShowPassword } from "../AuthShowPassword";
import { useResetPasswordContext } from "./ResetPasswordProvider";
import React, { useState } from "react";
import { debounce } from "../../../../lib/generic";
import { AppTextInputProps } from "../../ui/input/AppTextInput";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { AppTooltip } from "../../ui/tooltip";
import { passwordRequirements } from "../../../../lib/constants";

export const ResetPasswordInput = () => {
  const { state, dispatch } = useResetPasswordContext();
  const [showPassword, setShowPassword] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const debouncePassword = debounce((newPassword: string) => {
    dispatch({ password: newPassword });
  }, 500);

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({ passwordError: "" });

    debouncePassword(event.target.value);

    if (event.target.value.length > 0) {
      setShowTooltip(true);
    }

    if (event.target.value.length === 0) {
      setShowTooltip(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={() => setShowTooltip(false)}>
      <div>
        <AppTooltip
          title={passwordRequirements}
          open={showTooltip}
          placement="top"
        >
          <AppTextInputForToolTip
            label={"Password"}
            value={state.password}
            error={!!state.passwordError}
            helperText={state.passwordError}
            type={showPassword ? "text" : "password"}
            onChange={handlePasswordChange}
            endIcon={
              <AuthShowPassword
                showPassword={showPassword}
                setShowPassword={setShowPassword}
              />
            }
          />
        </AppTooltip>
      </div>
    </ClickAwayListener>
  );
};

const AppTextInputForToolTip = React.forwardRef(function AppTextInputForToolTip(
  props: AppTextInputProps,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  return <AppTextInput ref={ref} {...props} />;
});
